<template>
  <div class="search">
    <form v-on:submit.prevent="search" autocomplete="search" spellcheck="off">
      <label for="search-input">Add gamertag:</label>
      <span class="search-control">
        <input type="search" v-model="term" class="form-control" id="search-input" />
        <button type="submit" class="btn">Search</button>
      </span>
    </form>

    <ul id="results">
      <li v-for="result in results" :key="result.bungieNetMembershipId" class="result">
        <button @click="resultClick(result.destinyMemberships[0].membershipType, result.destinyMemberships[0].membershipId)">
          <img :src="'https://www.bungie.net' + result.destinyMemberships[0].iconPath" :alt="basename(result.destinyMemberships[0].iconPath)">
          <span>{{ result.bungieGlobalDisplayName + '#' + result.bungieGlobalDisplayNameCode.toString().padStart(4, "0") }}</span>
        </button>
        <!--
        <button v-for="membership in result.destinyMemberships" :key="membership.membershipId" @click="resultClick(membership.membershipType, membership.membershipId)">
          <img :src="'https://www.bungie.net' + membership.iconPath" :alt="basename(membership.iconPath)">
          <span>{{ membership.bungieGlobalDisplayName + '#' + membership.bungieGlobalDisplayNameCode.toString().padStart(4, "0") }}</span>
        </button>
        -->
      </li>
    </ul>

    <button v-if="results && results.length || message" id="close-button" title="Close results" @click="closeClick()">
      &times;
    </button>

    <div v-if="message" id="message" v-html="message"></div>
    
  </div>
</template>

<style lang="scss" scoped>
@import "@/styles/global.scss";
.search {
  position: absolute;
  top: 4px;
  background: lighten($color: $cell-background, $amount: 10);;
  color: $cell-text;
  padding: 5px;
  label {
    display: inline-block;
    margin-right: 4px;
  }
  .search-control {
    white-space: nowrap;
    button {
      background: darken($color: $cell-background, $amount: 1);
      border: none;
    }
  }
  #search-input {
    width: 8rem;
  }
  #results {
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      button {
        background: darken($color: $cell-background, $amount: 15);
        color: #ffffff;
        margin: 4px;
        padding: 8px;
        border: none;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 1rem;
          height: 1rem;
          margin-right: 0.5rem;
        }
      }
    }
  }
  #close-button {
    position: absolute;
    right: 10px;
    top: 50px;
    border: none;
    background: darken($color: $cell-background, $amount: 1);
  }
  #message {
    font-style: italic;
    min-height: $control-height;
    display: flex;
    align-items: center;
  }
}
</style>

<script>
import { mapState } from 'vuex'
import * as api from '@/api'
import * as general from '@/utils/general'

export default {
  name: "searchDestiny",
  data() {
    return {
      term: "",
      results: [],
      message: "",
    };
  },
  computed: mapState([
    'players'
  ]),
  methods: {
    search: function() {
      if (!this.term) return;
      // hide auto-complete popup
      const searchInput = document.getElementById('search-input');
      searchInput.blur();
      searchInput.focus();
      // search
      this.message = '<div><span class="spinner"></span> Searching...</div>';
      this.results = [];
      api.searchDestinyPlayer(this.term)
        .then(res => {
          this.results = res.searchResults;
          general.debug('searchresult', this.results);
          if (this.results.length === 0) {
            this.message = "No results found."
          } else {
            this.message = "";
          }
        });
    },
    resultClick: async function(membershipType, membershipId) {
      this.results = [];
      this.message = '<div><span class="spinner"></span> Fetching profile...</div>';
      await general.refreshPlayer(membershipType, membershipId);
      general.debug('players', this.players);
      this.message = "";
      this.term = "";
    },
    closeClick: function() {
      this.results = [];
      this.message = "";
    },
    basename: function basename(path) {
      return path.split('/').reverse()[0];
    }
  }
};
</script>